import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AttributesProps } from '../service/attributes.interface';
import { RootState } from '../../../../../store';

interface AttributesState {
    items: AttributesProps[];
    total: number;
    isLoading: boolean;
    isSuccess: boolean;
    error: string | null;
    is_ai_recommends: boolean;
}

const initialState: AttributesState = {
    items: [],
    total: 0,
    isLoading: false,
    isSuccess: false,
    error: null,
    is_ai_recommends: false,
};

export const attributesSlice = createSlice({
    name: 'attributesState',
    initialState,
    reducers: {
        setAIRecommends(state, action: PayloadAction<boolean>) {
            state.is_ai_recommends = action.payload;
        },
        setAttributes(state, action: PayloadAction<AttributesProps[]>) {
            state.items = action.payload;
        },
        setTotal(state, action: PayloadAction<number>) {
            state.total = action.payload;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setSuccess(state, action: PayloadAction<boolean>) {
            state.isSuccess = action.payload;
        },
        setError(state, action: PayloadAction<string | null>) {
            state.error = action.payload;
        },
    },
});

export const { setAIRecommends } = attributesSlice.actions;

export const selectAttributesState = (state: RootState): AttributesState =>
    state.attributesState;

export const attributesReducer = attributesSlice.reducer;
